import {
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@chakra-ui/react';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { BrandInformationFormRef } from './BrandInformationForm';
import BrandInformationForm from './BrandInformationForm';

interface BrandInformationFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  defaultValues: {
    name: string;
    websiteUrl: string;
    city: string;
    addressLine1: string;
    addressLine2: string | null;
    postalCode: string;
    country: string;
    registrationNumber: string;
    vatNumber: string;
  };
}

const BrandInformationFormModal = ({
  isOpen,
  onClose,
  defaultValues,
}: BrandInformationFormModalProps) => {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const formRef = useRef<BrandInformationFormRef>(null);

  const handleSubmit = () => {
    if (formRef.current) {
      formRef.current.submit();
    }
  };

  return (
    <DialogRoot open={isOpen} onOpenChange={onClose} closeOnInteractOutside={false}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('settings.brandInformationModal.title')}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <BrandInformationForm
            ref={formRef}
            defaultValues={defaultValues}
            onSubmitting={setIsSubmitting}
            onSuccess={onClose}
          />
        </DialogBody>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            {t('common.cancel')}
          </Button>
          <Button onClick={handleSubmit} loading={isSubmitting} disabled={isSubmitting}>
            {t('common.save')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
};

export default BrandInformationFormModal;
